import { useCallback, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { normalizeMascot } from "./mascotMood";
import useMyMascot from "./useMyMascot";

/**
 * Shares this player's mascot on the room (rooms/{id}.mascots.{uid}) so the
 * other players' review cards can draw it, and returns a lookup from player
 * id to mascot. Players who haven't shared one (e.g. older clients) get the
 * default Namey.
 */
export default function useRoomMascots(roomDocId, roomData, currentUserId) {
  const mine = useMyMascot();
  const mascots = roomData?.mascots;
  const shared = mascots?.[currentUserId];
  const isPlayer = !!roomData?.players?.some((p) => p.id === currentUserId);
  const upToDate =
    shared?.base === mine.base && shared?.color === mine.color && shared?.face === mine.face;

  useEffect(() => {
    if (!roomDocId || !currentUserId || !isPlayer || upToDate) return;
    updateDoc(doc(db, "rooms", roomDocId), {
      [`mascots.${currentUserId}`]: { base: mine.base, color: mine.color, face: mine.face },
    }).catch((err) => console.error("Failed to share mascot with room:", err));
  }, [roomDocId, currentUserId, isPlayer, upToDate, mine.base, mine.color, mine.face]);

  return useCallback(
    (playerId) => (playerId === currentUserId ? mine : normalizeMascot(mascots?.[playerId])),
    [currentUserId, mine, mascots]
  );
}
